import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "menu_container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item_img_wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "badge"
}
const _hoisted_6 = { class: "item_text" }

import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { handleExternalUrl, isWeimobMallForMenu } from '@/utils/navigation'
import { isWechat } from '@/utils/weixin'
import { storeToRefs } from 'pinia'
import { useUsersStore } from '@/stores/users'
import { TabData } from '@/api/Models/AppTabs'

interface TItem {
  dataJumpType: number
  dataJumpUrl: string
  dataJumpId: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
    data: {},
    badgeNum: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

const usersStore = useUsersStore()
const { tabOptions } = storeToRefs(usersStore)
const hasLecturerNavgation = computed(() => {
  return tabOptions.value.find((item: TabData) => {
    return item.defaultCode === 'lecturer'
  })
})

const skipHandle = (item: TItem) => {
  switch (item.dataJumpType) {
    case 3: // 链接
      handleExternalUrl({ jumpUrl: item.dataJumpUrl })
      break
    case 8: // ceo
      router.push('/ceo')
      break
    case 11: // 我的任务
      router.push('/task')
      break
    case 12: // 培训
      router.push('/myTraining')
      break
    case 13: // 课程
      router.replace('/course')
      break
    case 14: // 行业动态
      router.push('/broadcast')
      break
    case 15: // 社区
      router.replace('/community')
      break
    case 16: // 直播
      router.push('liveStream')
      break
    case 18: // 课程分类
      router.replace('/course?category=' + item.dataJumpId)
      break
    case 22: // 商城
      router.push('/shopIndex')
      break
    case 23: // 报名中心
      router.push('/applyCenter')
      break
    case 27: // 讲师中心
      hasLecturerNavgation.value ? router.replace('/lecturerCenterTab') : router.push('/lecturerCenter')
      break
    default:
      break
  }
}

const menuData = computed(() => {
  try {
    console.log('menuData')

    console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const filterMenuData = computed(() => {
  return menuData.value.filter((item: TItem) => {
    if (isWeimobMallForMenu(item) && isWechat) {
      return false
    }
    return true
  })
})
const dataMaxCount = computed(() => {
  return props.data.dataMaxCount
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterMenuData.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "menu_item",
        style: _normalizeStyle({ width: dataMaxCount.value % 4 === 0 ? '25%' : '20%' }),
        key: index,
        onClick: ($event: any) => (skipHandle(item))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "item_img",
            src: item.dataImgUrl
          }, null, 8, _hoisted_4),
          (_ctx.badgeNum > 0 && item.dataJumpType === 11)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.badgeNum > 99 ? '99+' : _ctx.badgeNum), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(item.dataName), 1)
      ], 12, _hoisted_2))
    }), 128))
  ]))
}
}

})